import { Divider, Typography } from "antd";
import StoreIcon from "assets/storeIcon";
import { BuyProductViewModel } from "models/buyProductDetailModel";

interface IProps {
  productData: BuyProductViewModel | undefined;
}

const StoreDetail: React.FC<IProps> = ({ productData }) => {
  const { Text } = Typography;

  return (
    <>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
      >
        <StoreIcon
          style={{
            border: "1px solid #f7f7f7",
            width: "25px",
            height: "25px",
            padding: "4px",
            borderRadius: "100%",
          }}
        />
        <Text style={{ marginLeft: "10px" }} type="success" strong>
          {productData?.getStore()?.getName()}
        </Text>
      </div>

      <Divider style={{ margin: "0px 0" }} />
      <p>
        Availability Status :{" "}
        <Text strong>{productData?.getStore()?.getAvailabilityStatus()}</Text>
      </p>
    </>
  );
};

export default StoreDetail;
